// src/components/dashboard/stats/WeekChart.tsx

import { useEffect, useState } from 'react';
import { WeekHistory } from '../types';

interface WeekChartProps {
    weekHistory: WeekHistory[];
}

export function WeekChart({ weekHistory }: WeekChartProps) {
    const [activeBar, setActiveBar] = useState<number>(-1);

    useEffect(() => {
        if (!weekHistory || weekHistory.length === 0) return;

        setActiveBar(-1);

        let index = -1;

        const interval = setInterval(() => {
            index += 1;
            setActiveBar(index);

            if (index >= weekHistory.length - 1) {
                clearInterval(interval);
            }
        }, 300); // 👉 intervalo entre barras (não é a animação)

        return () => clearInterval(interval);
    }, [weekHistory]);

    if (!weekHistory || weekHistory.length === 0) return null;

    const maxValue = Math.max(...weekHistory.map(d => d.cardsStudied), 1);

    return (
        <div className="dsb-estx-sem-chart">
            <h3>Histórico semanal</h3>

            <div className="dsb-estx-sem-chart-bars">
                {weekHistory.map((day, index) => {
                    const heightPercent = (day.cardsStudied / maxValue) * 100;
                    const isActive = index <= activeBar;

                    return (
                        <div key={index} className="dsb-estx-sem-bar-container">
                            <div className="dsb-estx-sem-bar-wrapper">

                                {/* Número sempre acima da barra */}
                                {isActive && day.cardsStudied > 0 && (
                                    <span style={{
                                        position: 'absolute',
                                        bottom: `${heightPercent}%`,
                                        left: '50%',
                                        transform: 'translateX(-50%)',
                                        fontSize: 11,
                                        fontWeight: 700,
                                        color: 'var(--btn-primary)',
                                        whiteSpace: 'nowrap',
                                        marginBottom: 4,
                                        pointerEvents: 'none',
                                    }}>
                                        {day.cardsStudied}
                                    </span>
                                )}

                                <div
                                    className={`dsb-estx-sem-bar ${isActive ? 'active' : ''} ${day.isProductiveDay ? 'productive' : ''}`}
                                    style={{
                                        '--bar-height': `${heightPercent}%`
                                    } as React.CSSProperties}
                                />
                            </div>

                            <span className="dsb-estx-sem-chart-label">
                                {day.dayLabel}
                            </span>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
